// PHASE 8: Can you see yourself living in your dream space?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'designIdentityShift'

const OPTIONS = [
  {
    value: 'Absolutely, I can visualize it clearly',
    translationKey: 'pages.onboarding.v2.designIdentityShift.options.clearly',
    emoji: '✨',
  },
  {
    value: 'Yes, but I need help making it real',
    translationKey: 'pages.onboarding.v2.designIdentityShift.options.needHelp',
    emoji: '🤝',
  },
  {
    value: 'Sometimes, when I see inspiration',
    translationKey: 'pages.onboarding.v2.designIdentityShift.options.sometimes',
    emoji: '💭',
  },
  {
    value: 'Not yet, but I want to',
    translationKey: 'pages.onboarding.v2.designIdentityShift.options.notYet',
    emoji: '🌱',
  },
]

export default function DesignIdentityShiftPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Can you see yourself living in your dream space?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.designIdentityShift.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
